import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../Sidebar";
export default function MainPage() {
  return (
    <div className="container">
      <div className="sidebar">
        <Sidebar />
        <h2 id="tabler">Reports</h2>
      </div>
      <div id="tabler1">
        <div className="tables-option-div">
          <div className="row">
            <div className="col-4">
              <div className="tables-options">
                <Link to="/create-report">
                  <button
                    type="button"
                    className="btn btn-success table-buttons"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-file-earmark-arrow-up-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.354 9.854a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 8.707V12.5a.5.5 0 0 1-1 0V8.707L6.354 9.854z" />
                    </svg>{" "}
                    Create Report
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <DynamicReportsTable />
      </div>
    </div>
  );
}

const DynamicReportsTable = () => {
  const [reports, setReports] = useState([]);

  const fetchReports = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/dynamicReports/list`
      );
      const data = await res.json();
      setReports(data.data || []);
    } catch (err) {
      console.error("Error fetching reports:", err);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const handleDeleteReport = async (id, reportName) => {
    if (!window.confirm(`Are you sure you want to delete "${reportName}"?`)) {
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/dynamicReports/delete/${id}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        alert("Report deleted successfully");
        fetchReports(); // Refresh the list
      } else {
        const error = await response.json();
        alert(error.message || "Failed to delete report");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while deleting the report");
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Available Reports</h3>
      <div className="table-responsive">
        <table className="table table-striped table-hover table-bordered align-middle">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Report Name</th>
              <th>Type</th>
              <th>Commodities</th>
              <th>Publish Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {reports.length > 0 ? (
              reports.map((r, i) => (
                <tr key={r._id}>
                  <td>{i + 1}</td>
                  <td>{r.reportName}</td>
                  <td>{r.reportType}</td>
                  <td>
                    {Array.isArray(r.commodity)
                      ? r.commodity.join(", ")
                      : r.commodity}
                  </td>
                  <td>{new Date(r.date).toLocaleDateString("en-GB")}</td>
                  <td>
                    <div className="btn-group">
                      {r.file?.url && (
                        <button
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => window.open(r.file.url, "_blank")}
                        >
                          View
                        </button>
                      )}
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDeleteReport(r._id, r.reportName)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No reports available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
